module.exports = __webpack_public_path__ + "public/images/investing.86d3d7743160bdd276a87742c89a6bd9.jpg";